import React from 'react';
import { HeroSection } from './components/HeroSection';
import { MenuSection } from './components/MenuSection';
export function App() {
  return <main className="min-h-screen w-full bg-white text-ink selection:bg-ink/10 selection:text-ink overflow-x-hidden" data-id="element-0" data-mp="35c24ait1n9xv">
      <HeroSection data-id="element-1" data-mp="3k78bh93vless" />
      <MenuSection data-id="element-2" data-mp="3f9ygldxpwaxk" />
    </main>;
}